import type { ResourceTypeHandle } from '@toolproof-core/genesis/_contract/_index';

import type { ResourcesByType } from '@toolproof-core/lib/_contract/resources';

import type { BiologyCosmosData } from '@/adapters/biology/_contract/proteinStructure';

export function buildCosmosData(
    resourcesByType: ResourcesByType<ResourceTypeHandle>,
): BiologyCosmosData {
    return { resourcesByType };
}
